// framer
import { m } from "framer-motion";
// @mui
import { alpha, styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
// types
import { FC } from "react";
import { Logo } from "../Logo";

const RootStyle = styled("div")(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 99999,
  width: "100%",
  height: "100%",
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
}));

interface LoadingProps {
  isDashboard?: boolean;
}
export const Loading: FC<LoadingProps> = (props) => {
  const { isDashboard, ...other } = props;
  return (
    <>
      <RootStyle {...other}>
        <m.div
          initial={{ rotateY: 0, scale: 0.8 }}
          animate={{ rotateY: 360, scale: 1 }}
          transition={{
            duration: 1.6,
            ease: "easeInOut",
            repeatDelay: 0.3,
            repeat: Infinity,
          }}
        >
          <Logo sx={{ width: 64, height: 64 }} />
        </m.div>

        <Box
          component={m.div}
          animate={{
            scale: [1.2, 1, 1, 1.2, 1.2],
            rotate: [270, 0, 0, 270, 270],
            opacity: [0.25, 1, 1, 1, 0.25],
            borderRadius: ["25%", "25%", "50%", "50%", "25%"],
          }}
          transition={{ ease: "linear", duration: 2.8, repeat: Infinity }}
          sx={{
            width: 100,
            height: 100,
            borderRadius: "25%",
            position: "absolute",
            border: (theme) =>
              `solid 3px ${alpha(theme.palette.primary.main, 0.24)}`,
          }}
        />

        <Box
          component={m.div}
          animate={{
            scale: [1, 1.2, 1.2, 1, 1],
            rotate: [0, 270, 270, 0, 0],
            opacity: [1, 0.25, 0.25, 0.25, 1],
            borderRadius: ["25%", "25%", "50%", "50%", "25%"],
          }}
          transition={{
            ease: "linear",
            duration: 2.8,
            repeat: Infinity,
          }}
          sx={{
            width: 120,
            height: 120,
            borderRadius: "25%",
            position: "absolute",
            border: (theme) =>
              `solid 6px ${alpha(theme.palette.primary.main, 0.18)}`,
          }}
        />
      </RootStyle>
    </>
  );
};
